// extracted by mini-css-extract-plugin
export default {"container":"VE6j","scrollUpBtn":"_x1E","slide-in-bottom":"wj5r","scrollUpBtnDisbled":"yhFw"};